import { render, staticRenderFns } from "./LoginOwner.vue?vue&type=template&id=39a1fc4d&"
import script from "./LoginOwner.vue?vue&type=script&lang=js&"
export * from "./LoginOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports